import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { transportsApi } from "@/lib/api";
import type { TransportCreate, TransportUpdate } from "@/types";

export function useTransports() {
  return useQuery({
    queryKey: ["transports"],
    queryFn: () => transportsApi.list(),
  });
}

export function useTransport(id: string) {
  return useQuery({
    queryKey: ["transports", id],
    queryFn: () => transportsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateTransport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: TransportCreate) => transportsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["transports"] }),
  });
}

export function useUpdateTransport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: TransportUpdate }) =>
      transportsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["transports"] }),
  });
}

export function useDeleteTransport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => transportsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["transports"] }),
  });
}
